import React, { Component } from 'react';
import { formatCurrency } from '@C/TableGrid';

class CashBook extends Component {
  constructor() {
    super();
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header />
          <main>
            <table className="dsr" data-name="Cash Book">
              <thead>
                <tr data-header={true}>
                  <th className="alert-brand" colSpan="2">
                    Cash Book
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Opening cash balance</td>
                  <td>{formatCurrency(summary.opening_balance || 0)}</td>
                </tr>
                <tr>
                  <td>Cash received from duties</td>
                  <td>
                    {formatCurrency(summary.cash_received_from_duties || 0)}
                  </td>
                </tr>
                <tr>
                  <td>Office Incomes</td>
                  <td>{formatCurrency(summary.office_income || 0)}</td>
                </tr>
                <tr>
                  <td>Office Expenses</td>
                  <td>{formatCurrency(summary.office_expense || 0)}</td>
                </tr>
                <tr>
                  <td>Cash deposit to bank</td>
                  <td>{formatCurrency(summary.cash_deposit_to_bank || 0)}</td>
                </tr>
                <tr>
                  <td>Closing cash balance</td>
                  <td>{formatCurrency(summary.closing_balance || 0)}</td>
                </tr>
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
export default CashBook;
